import React, { useEffect, useState } from 'react';
import ProductList from './ProductList';
import NavbarBack from './NavbarBack'; // Make sure the path is correct

const CartPage = () => {
  const [cartProductIds, setCartProductIds] = useState([]);
  const [allProducts, setAllProducts] = useState([]);

  const username = localStorage.getItem('username');

  useEffect(() => {
    if (!username) return;

    // Fetch all product details
    fetch('https://reviewhub-lc.onrender.com/api/reviews/all')
      .then((res) => res.json())
      .then((data) => setAllProducts(data));

    // Fetch user cart (just product IDs)
    fetch('https://reviewhub-lc.onrender.com/api/auth/get-cart', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username }),
    })
      .then((res) => res.json())
      .then((data) => setCartProductIds(data.cart || []));
  }, [username]);

  const cartProducts = allProducts.filter((p) => cartProductIds.includes(p._id));
const handleRemoveFromCart = async (productId) => {
  try {
    const response = await fetch('https://reviewhub-lc.onrender.com/api/auth/remove-from-cart', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, productId }),
    });

    if (!response.ok) {
      throw new Error('Server responded with error');
    }

    // Update cart state locally after removing
    setCartProductIds(prev => prev.filter(id => id !== productId));

    // ✅ Alert message
    alert('Product removed from cart successfully!');
  } catch (err) {
    console.error('Failed to remove item:', err);
    alert('Failed to remove product from cart.');
  }
};



  return (
    <>
<NavbarBack title="My Cart" />
   <ProductList
  products={cartProducts}
  onRemove={handleRemoveFromCart}
  showFilters={false} 
/>

    </>
  );
};

export default CartPage;
